module.exports = __webpack_public_path__ + "static/media/logo-icon.99a01576.png";